<template>
  <span>
    <v-chip :small='small' label :dark='status.dark' :color='status.color' class='ml-1'>
      <v-icon :small='small' left>{{ status.icon }}</v-icon>
      {{ status.text }}
    </v-chip>
  </span>
</template>

<script>
// import wosServices from '../services/wos'
export default {
  name: 'wo-status',
  props: {
    wo: {
      required: true
    },
    small: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    status () {
      if (this.wo.status) {
        return this.$store.state.misc.globalOptions.woStatus.find(s => s.value == this.wo.status)
      }
      return { icon: 'mdi-help', color: 'warning', dark: true, text: 'Null' }
    }
  }
}
</script>
